<template>
  <div>
    <div
      class="fl-sym-relative fl-sym-inline-block fl-sym-w-10 fl-sym-mr-2 fl-sym-align-middle fl-sym-select-none fl-sym-transition fl-sym-duration-200 fl-sym-ease-in"
    >
      <input
        @click="toggleSwitch"
        type="checkbox"
        name="toggle"
        id="toggle"
        class="fl-sym-toggle-checkbox fl-sym-absolute fl-sym-block fl-sym-w-6 fl-sym-h-6 fl-sym-rounded-full fl-sym-bg-white fl-sym-border-0-5 fl-sym-appearance-none fl-sym-cursor-pointer fl-sym-outline-none"
      />
      <label
        for="toggle"
        class="fl-sym-toggle-label fl-sym-block fl-sym-overflow-hidden fl-sym-h-6 fl-sym-rounded-full fl-sym-bg-white fl-sym-cursor-pointer"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: false,
    }
  },
  methods: {
    toggleSwitch() {
      // REMINDER(IMPORTANT) - This need serious refactoring. It needs to take
      //                       in a proper prop and toggle the value and emit
      //                       he current boolean.
      this.$emit("input", !this.value)
    },
  },
}
</script>

<style>
.fl-sym-toggle-checkbox:checked {
  @apply: fl-sym-right-0 fl-sym-border-green-400 fl-sym-outline-none;
  right: 0;
  border-color: #53d5e6;
}
.fl-sym-toggle-checkbox:checked + .fl-sym-toggle-label {
  @apply: fl-sym-bg-green-400 fl-sym-outline-none;
  background-color: #53d5e6;
}
.fl-sym-toggle-label {
  border: 1px solid #0000001a;
}
.fl-sym-border-0-5 {
  border-width: 0.5px;
}
</style>
